import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AccountFetchFailedAction = {
	type: 'ACCOUNT_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AccountFetchFailedAction => ({
	type: 'ACCOUNT_FETCH_FAILED',
	payload,
});
